module.exports = __webpack_public_path__ + "img/avatar3.5d721fdc.png";